export default __webpack_public_path__ + "static/media/10.0e333f61.webp";